import React from "react"
import moment from "moment"
import { CustomServerSideReactTable } from "components/utility"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { GET_MAINTAIN_HISTORIES, DELETE_MAINTAIN_HISTORY, SUM_MAINTAIN_HISTORIES, GET_TABLE_FIELDS } from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const MaintainHistoryContainer = props => {
  const objectName = "耗材更換紀錄"

  useBread({ to: props.match.url, name: "耗材更換紀錄" }, true)

  const fieldsDefinition = () => {
    return [
      {
        id: "companyName",
        Header: "公司",
        style: columStyle,
        accessor: data => data.companyDevice?.company?.name,
        width: 200,
        // filterable: true,
        filterMethod: (filter, row) => row.companyName?.includes(filter.value)
      },
      {
        id: "deviceName",
        Header: "裝置名稱",
        style: columStyle,
        accessor: data => data.companyDevice?.device?.name,
        width: 200,
        // filterable: true,
        filterMethod: (filter, row) => row.deviceName?.includes(filter.value)
      },
      {
        id: "productName",
        Header: "耗材名稱",
        style: columStyle,
        accessor: data => data.product?.name,
        width: 200,
        // filterable: true,
        filterMethod: (filter, row) => row.productName?.includes(filter.value)
      },
      {
        id: "maintenanceTime",
        Header: "維護時間",
        style: columStyle,
        accessor: data => moment(data.maintenanceTime).format("YYYY-MM-DD"),
        width: 200,
        // filterable: true,
        filterMethod: (filter, row) =>
          row.maintenanceTime?.includes(filter.value)
      },
      {
        id: "content",
        Header: "內容",
        style: columStyle,
        accessor: "content",
        // filterable: true,
        filterMethod: (filter, row) => row.content?.includes(filter.value)
      },
      {
        id: "maintainUserName",
        Header: "維護人員",
        style: columStyle,
        width: 200,
        accessor: data => data.user?.name,
        // filterable: true,
        filterMethod: (filter, row) =>
          row.maintainUserName?.includes(filter.value)
      }
    ]
  }

  return (
    <CustomServerSideReactTable
      queryObjectGql={GET_MAINTAIN_HISTORIES}
      sumTotalQueryObjectGql={SUM_MAINTAIN_HISTORIES}
      deleteObjectGql={DELETE_MAINTAIN_HISTORY}
      fieldsDefGql={GET_TABLE_FIELDS}
      objectName={objectName}
      objectRoute={props.match.url}
      hasCreateButton={true}
      hasEditButton={true}
      hasDeleteButton={true}
      fieldsDef={fieldsDefinition()}
    />
  )
}

const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default withBreadcrumb(MaintainHistoryContainer)
